import { IBridgeApplicationGridRecord } from '@apply/api/src/api/applicationApi';
import { AppPropertyActionsButton } from '../actions/AppPropertyActionButton';

export const actionCellRender = (application: IBridgeApplicationGridRecord, e) => {
    //To do work for the team - actions menu parked for now
    if (application.loanId) {
        return <></>;
    }

    return (
        <AppPropertyActionsButton
            application={application}
            property={e.data}
            parentElementId='bridgePortfolioId'
        />
    );
};
